module.exports = __webpack_public_path__ + "img/fossil5Img3.d3306e76.jpg";